import { View } from 'okta';

export default View.extend({
  className: 'text-label',
  template: '{{label}}',
});
